import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { salesReturnViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesRet from "../../../components/sales-section/sales-return/create-edit-view-sales-ret";
const SalesReturnEdit = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(salesReturnViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    console.log(data?.data?.[0]?.orderData?.srt_pay_to_address);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Edit Sales Return">
          <CreateEditViewSalesRet
            page="edit"
            type={"return"}
            payto={orderDetail?.orderData?.srt_pay_to_address} //check
            shipto={orderDetail?.orderData?.srt_ship_to_address} //check
            pageType="sales return"
            disabled={
              true && orderDetail?.orderData?.srt_order_status !== "draft"
            }
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default SalesReturnEdit;
